import cloneDeep from 'lodash/cloneDeep';
import React, { createRef, RefObject } from 'react';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { IProvider, IProviders, ITags } from 'store/providers/providerTypes';
import { IQueryFilter } from 'store/entity/IQueryFilter';
import { appDispatch, ITasks, IUsers, RootState } from 'store/store';
import { ISearchParams, NumberOrNull, StringOrNull } from 'store/entity/types';
import {
  englishNumber,
  isANumber,
  convertNumbersToProperFormat,
} from 'utils/number';
// import ClassicEditor from '@rastech-inc/ckeditor';
import { redirectTo } from '@reach/router';
import ActionLink from 'components/ActionLink';
import Button from 'components/Button';
import { display } from 'components/ErrorView/ErrorDialog';
import Icon from 'components/Icon';
import Select, { IOption } from 'components/Select/Select';
import ResponseForm from 'components/SurveyResponses/ResponseForm';
import TaskSearch from 'components/TaskSearch';
import { DropzoneRenderArgs } from 'react-dropzone';
import { getDomainAndPort } from 'api/Utils';
import { fixModalFootPrint } from 'containers/Mobile/Profile/MobileProfileContainer';
import ItemTask from 'containers/Profile/Panels/DocumentManager/ItemTask';
import { getRedirectToLoginPath, isPrefix } from 'utils/happyFunctions';
import { red, black } from 'utils/style/colors';
import CKEditorField, {
  CKEditorReadOnlyConfig,
} from '../../../../CKEditorField/CKEditorField';
import Input from '../../../../Input/Input';
import { default as notify, default as Toast } from '../../../../Notify';
import { notifyError } from 'components/Notify/Notify';
import { getTextFilterdQuestions } from 'components/SurveyResponses/ResponseForm/ResponseForm';
import {
  HintIcon,
  HintText,
  QuestionHintBox,
} from '../SurveyEditor/GeneralQuestion/styles';
import UniqueQuestion from '../SurveyEditor/UniqueQuestion';
import { IDistinctiveLabel } from '../SurveyEditor/UniqueQuestion/UniqueQuestion';
import DistinctiveBadges from './DistinctiveBadges';
import ResponseList from './ResponseList';
import ResponseViewer from './ResponseViewer';
import {
  ClearSearchIcon,
  Description,
  DoneSubmit,
  LoadMoreResponsesContainer,
  LoadMoreText,
  ResponseListHeader,
  ResponseListWrapper,
  SearchIcon,
  SearchInput,
  SearchWrapper,
  surveyActionButtonStyle,
  ViewList,
  Wrapper,
} from './styles';
import {
  requireDocument,
  requireProviderTags,
  requireProviderTagsFn,
  searchProvider,
  searchProviderFn,
} from 'store/providers/providerSlice';
import { ICompany, ICompanyMemberRole } from 'store/companies/companiesTypes';
import {
  AutoRolePermissionSchemeIndex,
  isCompanyOwnerOrSupport,
} from 'store/companies/companiesUtils';
import {
  IAnswersView,
  IAnswerView,
  IMultipleChoiceQuestionView,
  IQuestionsView,
  ISurveyItem,
  ISurveyItemWithData,
  ISurveyResponseView,
  ISurveyView,
  ISurveyViewWithData,
  PeriodType,
  SurveyType,
  TimeScale,
} from 'store/survey/surveyTypes';
import { IThisUserState, logoutUser } from 'store/thisUser/thisUserSlice';
import {
  addResponse,
  addResponseFn,
  exportResponses,
  exportResponsesFn,
  filterResponsesByDistinctive,
  filterResponsesByDistinctiveFn,
  getNotifications,
  getNotificationsFn,
  importResponse,
  removeResponse,
  removeResponseFn,
  requireResponsesWithUsers,
  requireResponsesWithUsersFn,
  requireResponseWithId,
  requireResponseWithIdFn,
  updateResponse,
  updateResponseFn,
} from 'store/survey/surveySlice';
import { IAnalyticsListQuery } from 'store/entity/IAnalyticsListQuery';
import { IExportResponsesQuery } from 'store/entity/IExportResponsesQuery';
import {
  requireSeveralUser,
  requireSeveralUserFn,
} from 'store/users/usersSlice';
import {
  markTaskAssignment,
  markTaskAssignmentFn,
  searchTasks,
  searchTasksFn,
} from 'store/tasks/tasksSlice';
import { IAssignmentView } from 'store/tasks/tasksType';
import {
  getCompanyHandler,
  getCompanyHandlerFn,
} from 'store/companies/companiesSlice';
import { WithTranslation, withTranslation } from 'react-i18next';
import i18n, { languageDirection } from '../../../../../i18n';
import messages from './Messages';
import axios from 'axios';
import { getFinalUrl } from './dataSourceHelper';
import UserMixpanel from '../../../../../utils/mixpanel/MixpanelClass';
import { ITaskSurveyResponse } from './ResponseItem';
import RatingForm from 'components/RatingFormModal/RatingFormModal';
import FollowupQuestionsModal from './FollowupQuestionsModal';
import IsolatedPage from 'components/Modal/IsolatedHtml';

interface IStateToProps {
  tags?: ITags['data'] | null;
  users: IUsers['map'];
  survey: ISurveyViewWithData;
  isUniquePerDevice: boolean;
  providers: IProviders;
  provider: IProviders['map'][0];
  tasks: ITasks;
  userRoles?: number[];
  canCreateTemplates: { id: number; title: string }[];
  allTemplatesWithRelatedItem: { id: number; title: string }[];
  thisUserId: number;
  thisUser: IThisUserState;
  providerId?: number;
  isAllResponsesLoaded?: boolean;
  currentUserCompanyRoles: number[];
  company?: ICompany;
  isAdminOrSupport?: boolean;
  surveyResponseProgress?: Record<string, number>;
}

let savedDistinctiveValues: { [key: string]: string } | undefined = undefined;
const pageSize = 50;
interface IDispatchToProps {
  logOutUser: () => void;
  requireSeveralUser: (
    userIds: number[]
  ) => ReturnType<typeof requireSeveralUserFn>;
  addResponse: (
    response: ISurveyResponseView,
    surveyItemData: ISurveyItem,
    dontSendNotification: boolean,
    periodType: PeriodType
  ) => ReturnType<typeof addResponseFn>;
  importResponses: (
    file: File,
    surveyItemData: ISurveyItem,
    dontSendNotification: boolean,
    companyId: number
  ) => Promise<any>;
  getNotifications: (
    response: ISurveyResponseView,
    surveyItemData: ISurveyItem
  ) => ReturnType<typeof getNotificationsFn>;
  removeResponse: (
    responseId: number,
    surveyItemData: ISurveyItem
  ) => ReturnType<typeof removeResponseFn>;
  updateResponse: (
    response: ISurveyResponseView,
    surveyItemData: ISurveyItem,
    dontSendNotification: boolean
  ) => ReturnType<typeof updateResponseFn>;
  requireResponsesWithUsers: (
    surveyItemData: ISurveyItem,
    start: number,
    count: number,
    instance?: number,
    thisUserId?: number,
    order?: string,
    extraFilters?: IQueryFilter[]
  ) => ReturnType<typeof requireResponsesWithUsersFn>;
  requireResponseWithId: (
    surveyItemData: ISurveyItem,
    responseId: number
  ) => ReturnType<typeof requireResponseWithIdFn>;
  filterResponses: (
    filters: IQueryFilter[]
  ) => ReturnType<typeof filterResponsesByDistinctiveFn>;
  searchProvider: (
    queryString: string,
    variant?: string | null,
    start?: number,
    count?: number
  ) => ReturnType<typeof searchProviderFn>;
  requireProviderTags: (
    providerId: number
  ) => ReturnType<typeof requireProviderTagsFn>;
  exportResponses: (
    dataQuery: IExportResponsesQuery,
    surveyToken?: string,
    ownerToken?: string,
    reportToken?: string
  ) => ReturnType<typeof exportResponsesFn>;
  searchTasks: (params: ISearchParams) => ReturnType<typeof searchTasksFn>;
  markTaskAssignment: (
    assignment: IAssignmentView
  ) => ReturnType<typeof markTaskAssignmentFn>;
  getCompany: (companyId: number) => ReturnType<typeof getCompanyHandlerFn>;
}

interface IOwnProps {
  surveyItem: ISurveyItemWithData;
  filteredResponseId?: number;
  showCorrectAnswers?: boolean;
  extraTagIds?: number[];
  lastPossibleSubmitTime?: number;
  openNextItem?: () => void;
  visible?: boolean;
  limitRelatedUsers?: number[];
  filteredQuestionTagId?: number[];
  pdpInfo?: {
    phase?: string;
  };
  surveyType?: SurveyType;
}

type IComponentProps = IOwnProps &
  IDispatchToProps &
  IStateToProps &
  WithTranslation;

interface IComponentState {
  from: number;
  loading: boolean;
  loadingCompany?: boolean;
  isUnique: boolean;
  periodType?: TimeScale;
  viewingPeriodType?: TimeScale;
  responseId?: number;
  disableForm: boolean;
  requestSent: boolean;
  forceAnalyse?: boolean;
  loadingSubmit?: boolean;
  showResponseForm: boolean;
  distinctiveValues?: { [key: string]: string };
  textFilterValues?: { [key: string]: string };
  distinctiveValuesForFilter?: { [key: string]: string };
  distinctiveLabels?: { [field: string]: IDistinctiveLabel };
  selectedResponseId: NumberOrNull;
  selectedProviderId?: number;
  showDistinctiveForm: boolean;
  showDoneSubmit: boolean;
  filteredResponsesIds?: number[];
  currentFilter?: IQueryFilter[];
  loadingExport: boolean;
  importWarningMessage?: string;
  sentResponseId?: number;
  filteredResponseId?: number;
  fetchPrevResponsesForFirstTime?: boolean;
  permissionSchemeFilters: IQueryFilter[];
  order: 'submitDate desc' | 'updateDate desc' | 'effectiveDate desc';
  showTaskModal?: {
    templateId?: number;
    responseId?: number;
    templateTitle?: string;
    taskId?: number;
    taskSurveyResponse?: ITaskSurveyResponse;
  };
  toImportFile?: File;
  randomInput?: boolean;
  isAllResponsesLoaded?: boolean;
  externalDataSourceValues?: { [key: string]: any };
  failedToFetchExternalSourceValues?: boolean;
  showRatingForm?: boolean;
  showFollowupModal: boolean;
  followUpQuestionsInfo: Record<string, string>;
  htmlUrl: string;
}

const getUniqueSurveyKey = (survey: ISurveyViewWithData) => {
  return 'filledSurvey_' + survey.data.id;
};

export const getValidChoices = (
  company: ICompany,
  permissionScheme: number[],
  currentUserCompanyRoles: number[],
  activeRelatedPermissions: any,
  extraFilterList?: number[]
) => {
  let validChoices: number[] | undefined;

  if (company && permissionScheme.length > 0) {
    validChoices = [];
    permissionScheme.forEach((ps) => {
      validChoices = [
        ...(validChoices || []),
        ...Object.entries(
          company?.permissionSchemes?.[ps]?.properties?.roleIdTagIdListMap ?? {}
        ).reduce((current: number[], [key, value]) => {
          if (
            currentUserCompanyRoles &&
            currentUserCompanyRoles.includes(Number(key))
          ) {
            activeRelatedPermissions = activeRelatedPermissions.filter(
              (it: string) =>
                it !== `R${key}` &&
                !(
                  company.roles[Number(it.substr(1))]?.autoAddPrefix &&
                  isPrefix(
                    company.roles[Number(it.substr(1))]?.name,
                    company.roles[key].name
                  )
                )
            ); // remove role related to permission scheme
            current = [...current, ...value];
          }
          return current;
        }, [] as number[]),
      ];
      activeRelatedPermissions = activeRelatedPermissions.filter(
        // remove compounding role from permission scheme
        (it: string) => it !== `R${ps - AutoRolePermissionSchemeIndex}`
      ); // remove role related to permission scheme
    });
    if (activeRelatedPermissions.length) {
      // there exist a role not related to permission scheme so all items will be available
      validChoices = undefined;
    }
  } else {
    validChoices = undefined;
  }
  if (extraFilterList) {
    if (validChoices === undefined) validChoices = extraFilterList;
    else
      validChoices = validChoices.filter((it) => extraFilterList.includes(it));
  }
  return validChoices;
};

class SurveyResponseViewer extends React.Component<
  IComponentProps,
  IComponentState
> {
  searchValue: any = React.createRef();
  activeLanguage = i18n.language;
  responseListOrder = [
    {
      label: i18n.t('submitDate_desc', { ns: 'survey' }),
      value: 'submitDate desc',
    },
    {
      label: i18n.t('updateDate_desc', { ns: 'survey' }),
      value: 'updateDate desc',
    },
    {
      label: i18n.t('effectiveDate_desc', { ns: 'survey' }),
      value: 'effectiveDate desc',
    },
  ];

  importFromExcel = () => {
    this.setState({ loadingExport: true });
    const companyId = this.props.company?.id as number;
    if (!this.state.toImportFile) return;
    this.props
      .importResponses(
        this.state.toImportFile,
        this.props.surveyItem.data,
        false,
        companyId
      )
      .then(
        (r) => {
          if (r.data.notInserted.length > 0) {
            this.setState({
              importWarningMessage: r.data.notInserted.reduce(
                (current: string, item: number) => {
                  return current + item + '، ';
                },
                this.props.t('notImportedRows')
              ),
            });
          } else {
            notify(
              this.props.t('numberOfRowsImported', {
                size: r.data.inserted.length,
              }),
              'successful',
              false
            );
          }
          this.setState({ loadingExport: false });
        },
        (e) => {
          this.setState({ loadingExport: false });
          notifyError(e);
        }
      );
  };

  constructor(props: IComponentProps) {
    super(props);
    const { survey } = props;
    const surveyData = survey.data;
    const isUnique = surveyData.keepUnique;
    const periodType = surveyData.periodType;
    this.state = {
      from: pageSize,
      loading: true,
      isUnique,
      responseId: undefined,
      periodType: periodType !== 'none' ? periodType : undefined,
      viewingPeriodType: periodType !== 'none' ? periodType : 'month',
      requestSent: false,
      disableForm: false,
      forceAnalyse: undefined,
      loadingSubmit: undefined,
      showResponseForm: false,
      distinctiveValues: savedDistinctiveValues,
      distinctiveValuesForFilter: savedDistinctiveValues,
      selectedResponseId: props.filteredResponseId || null,
      showDistinctiveForm: false,
      showDoneSubmit: false,
      selectedProviderId: undefined,
      loadingExport: false,
      order: 'updateDate desc' as const,
      filteredResponseId: props.filteredResponseId,
      permissionSchemeFilters: this.getPermissionSchemeFilters(),
      fetchPrevResponsesForFirstTime: false,
      showFollowupModal: false,
      followUpQuestionsInfo: {},
      htmlUrl: '',
    };
  }

  setOrder(order: IComponentState['order']) {
    this.setState({
      order: order as any,
      from: 0,
    });
    this.handleRequireResponses(0, order)();
  }
  includeScore: RefObject<HTMLInputElement> = createRef();

  componentDidUpdate(prevProps: Readonly<IComponentProps>) {
    if (
      prevProps.provider.isLoading !== this.props.provider.isLoading ||
      (this.props.company?.status !== 'loaded' && !this.state.loadingCompany)
    ) {
      const hasAnyQuestionWithPermissionScheme =
        this.getHasAnyQuestionWhichRequiresCompanyInfo();
      if (
        hasAnyQuestionWithPermissionScheme ||
        this.props.surveyItem.data.instanceType === 'User'
      ) {
        this.setState({ loadingCompany: true });
        if (this.props.provider.data?.managingCompanyId)
          this.props.getCompany(this.props.provider.data!.managingCompanyId!);
      }
    }
    if (
      this.props.company?.status === 'loaded' &&
      prevProps.company?.status !== 'loaded'
    ) {
      this.setState(
        {
          loadingCompany: false,
          permissionSchemeFilters: this.getPermissionSchemeFilters(),
        },
        () => {
          this.fetchPrevResponses();
        }
      );
    }

    if (this.props.survey.viewingVersion !== prevProps.survey.viewingVersion)
      this.setState({ forceAnalyse: !this.state.forceAnalyse });
  }

  componentDidMount() {
    const { thisUserId, surveyItem, providerId, requireProviderTags, survey } =
      this.props;

    const visibilityStrategy = survey.data.visibilityStrategy;
    if (
      !surveyItem.data.reportToken &&
      (!visibilityStrategy ||
        (visibilityStrategy === 'personal' && thisUserId) ||
        visibilityStrategy === 'open')
    ) {
      this.setState({
        showResponseForm: true,
        showDistinctiveForm: survey.data.keepUnique,
        distinctiveValuesForFilter: this.state.distinctiveValues,
      });
    }
    const promises = [requireProviderTags(providerId as number)];

    const hasAnyQuestionWithPermissionScheme =
      this.getHasAnyQuestionWithPermissionScheme();
    if (thisUserId) {
      const fetch = this.fetchPrevResponses();
      promises.push(fetch);
    }
    const allowAnonymusUsers =
      (
        this.props.survey.data.fields.find(
          (x) => x.name === 'conf_allowAnonymousUsers'
        ) || {
          value: 'true',
        }
      ).value === 'true';
    if (
      !thisUserId &&
      (hasAnyQuestionWithPermissionScheme ||
        surveyItem.data.instanceType === 'User' ||
        survey.data.uniquePerUser ||
        survey.data.uniquePerInstance ||
        isANumber(survey.data.validListSize) ||
        !allowAnonymusUsers)
    ) {
      fixModalFootPrint();
      const loginMesage = (
        this.props.survey.data.fields.find(
          (x: any) => x.name === 'conf_loginMessage'
        ) || {
          value: '',
        }
      )?.value;
      redirectTo(getRedirectToLoginPath('-', loginMesage));
      return;
    }
    if (!thisUserId && !surveyItem.data.reportToken) {
      this.setState({
        showResponseForm: true,
        distinctiveValuesForFilter: this.state.distinctiveValues,
      });
    }
    if (
      (hasAnyQuestionWithPermissionScheme ||
        surveyItem.data.instanceType === 'User') &&
      this.props.thisUser.userId &&
      this.props.provider.data?.managingCompanyId &&
      this.props.company?.status !== 'loaded'
    ) {
      promises.push(
        this.props.getCompany(this.props.provider.data.managingCompanyId)
      );
    }

    if (this.state.filteredResponseId) {
      if (!this.props.survey.data?.responseMap?.[this.state.filteredResponseId])
        this.props.requireResponseWithId(
          this.props.surveyItem.data,
          this.state.filteredResponseId
        );
    }

    if (this.props?.survey?.data?.id) {
      const showResponseAsHtml = this.props.survey.data.fields.find(
        (it) => it.name === 'conf_htmlResponseDocumentUrl'
      );

      if (showResponseAsHtml) {
        const quillId = (showResponseAsHtml.value || '').split('/direct/')[1];
        if (quillId) {
          appDispatch(requireDocument({ documentId: Number(quillId) })).then(
            (res: any) => {
              if (
                res?.item?.document?.url &&
                Object.keys(this.props.survey.data.responseMap || {})
                  ?.length === 1
              ) {
                const response = Object.values(
                  this.props.survey.data.responseMap || {}
                )?.at(0);
                const questions =
                  this.props.survey.data.versions?.[response!.surveyVersion]
                    ?.questionMap;
                let params: string = '';
                response?.surveyAnswerList?.map((ans: IAnswersView) => {
                  const question = questions![ans.questionId];
                  const paramKey = question?.fields?.find(
                    (f: any) => f.name === 'conf_keyAsParamsOfResponse'
                  );
                  if (paramKey) {
                    params += `${paramKey.value}=${ans?.value ?? (ans as any)?.selected?.join(',') ?? (ans as any)?.values?.join(',')}&`;
                  }
                });
                if (params) {
                  const url = new URL(res.item.document.url);
                  url.search = params;
                  this.handleSetUrl(url.toString());
                }
              }
            }
          );
        }
      }
    }

    if (
      !this.props.surveyItem.data.reportToken &&
      this.props.survey.data.fields.find((it) => it.name === 'conf_dataSource')
    ) {
      const dataSource = this.props.survey.data.fields.find(
        (it) => it.name === 'conf_dataSource'
      )!.value!;
      if (dataSource === 'thisUser') {
        this.setState({ externalDataSourceValues: this.props.thisUser });
      } else {
        const url = getFinalUrl(dataSource);
        promises.push(
          axios
            .get(url)
            .then((res) => {
              this.setState({ externalDataSourceValues: res.data });
            })
            .catch(() => {
              this.setState({ failedToFetchExternalSourceValues: true });
            })
        );
      }
    }

    Promise.allSettled(promises)
      .then(() => {
        this.setState({ loading: false });
      })
      .catch((err) => {
        display(err);
      });
  }

  private fetchPrevResponses = () => {
    const { thisUserId, surveyItem, requireResponsesWithUsers } = this.props;
    const hasAnyQuestionWithPermissionScheme =
      this.getHasAnyQuestionWithPermissionScheme();
    if (
      !thisUserId ||
      (hasAnyQuestionWithPermissionScheme &&
        this.props.company?.status !== 'loaded' &&
        !this.props.surveyItem.data.changeDataToken)
    )
      return Promise.resolve();
    if (this.state.fetchPrevResponsesForFirstTime) return Promise.resolve();
    this.setState({ fetchPrevResponsesForFirstTime: true });
    const instance =
      surveyItem.data.instanceType === 'Provider'
        ? this.state.selectedProviderId
        : surveyItem.data.instanceType === 'User'
          ? (this.state.distinctiveValues &&
              this.state.distinctiveValues.instance &&
              Number(this.state.distinctiveValues.instance)) ||
            undefined
          : surveyItem.data.id;
    if (surveyItem.data.reportToken || thisUserId)
      return requireResponsesWithUsers(
        surveyItem.data,
        0,
        pageSize,
        instance,
        thisUserId,
        this.state.order,
        this.state.permissionSchemeFilters
      );
    else return Promise.resolve();
  };

  private getHasAnyQuestionWithPermissionScheme() {
    return Object.values(
      this.props.survey.data.versions[this.props.survey.data.currentVersion]
        ?.questionMap || {}
    )?.find((it) => {
      return (
        (this.props.surveyItem.data.reportToken &&
          ((it as IMultipleChoiceQuestionView)?.reportPermissionSchemeList
            ?.length ?? 0) > 0) ||
        ((it as IMultipleChoiceQuestionView).fillPermissionSchemeList?.length ??
          0) > 0
      );
    });
  }

  private getHasAnyQuestionWhichRequiresCompanyInfo() {
    return Object.values(
      this.props.survey.data.versions[this.props.survey.data.currentVersion]
        .questionMap || {}
    )?.find((it) => {
      return (
        (this.props.surveyItem.data.reportToken &&
          ((it as IMultipleChoiceQuestionView)?.reportPermissionSchemeList
            ?.length ?? 0) > 0) ||
        ((it as IMultipleChoiceQuestionView).fillPermissionSchemeList?.length ??
          0) > 0 ||
        it.viewableWith?.find((it: string) => it.startsWith('R')) ||
        it.editableWith?.find((it: string) => it.startsWith('R'))
      );
    });
  }

  canFetchAllResponses(survey: ISurveyItemWithData) {
    return (
      survey.data.changeDataToken ||
      survey.data.editToken ||
      survey.data.reportToken
    );
  }

  handleRequireResponses =
    (from?: number, order?: IComponentState['order']) => () => {
      const { thisUserId, surveyItem, requireResponsesWithUsers } = this.props;
      if (!thisUserId && !this.canFetchAllResponses(surveyItem)) {
        return;
      }
      this.setState({ requestSent: true });

      const realFrom = from !== undefined ? from : this.state.from;
      const instance =
        surveyItem.data.instanceType === 'Provider'
          ? this.state.selectedProviderId
          : surveyItem.data.id;
      requireResponsesWithUsers(
        surveyItem.data,
        realFrom,
        pageSize,
        instance,
        thisUserId,
        order || this.state.order,
        this.state.currentFilter
      ).then(
        (res) => {
          this.setState({
            requestSent: false,
            from: realFrom + pageSize,
            filteredResponsesIds: [
              ...(this.state.filteredResponsesIds || []),
              ...res.responses.map((it: any) => it.id),
            ],
            isAllResponsesLoaded: res.responses.length < pageSize,
          });
        },
        (err: any) => {
          this.setState({ requestSent: false });
          display(err);
        }
      );
    };

  handleChangeResponseViewer = (selectedResponseId: NumberOrNull) => {
    this.setState({ selectedResponseId });
  };

  handleRemove = (responseId: number) => {
    const { removeResponse, surveyItem } = this.props;
    if (this.state.selectedResponseId === responseId) {
      this.setState({ selectedResponseId: null });
    }
    return removeResponse(responseId, surveyItem.data);
  };

  handleUpdateSurvey = (newResponse: ISurveyResponseView) => {
    const { updateResponse, surveyItem } = this.props;
    return updateResponse(newResponse, surveyItem.data, false);
  };

  showInformationBasedOnResponseScore = (
    scoreRange: string,
    response: ISurveyResponseView
  ) => {
    const showFollowUp = this.props.survey.data.fields.find(
      (el) => el.name === 'conf_showFollowUpQuestionBasedOnScore'
    );
    const scoreRangeObject = JSON.parse(scoreRange) as Record<
      string,
      string | Record<string, string>
    >;
    const score = response?.score ?? 0;
    Object.entries(scoreRangeObject).some(([key, message]) => {
      const from = Number(key?.split('-')?.[0]);
      const to = Number(key?.split('-')?.[1]);
      if (score >= from && score <= to) {
        if (showFollowUp && typeof message === 'object') {
          this.setState({
            showFollowupModal: true,
            followUpQuestionsInfo: message,
          });
        } else {
          notify(message as string, 'info');
        }
        return true;
      }
      return false;
    });
  };

  handleSaveResponse = async (
    answerList: ISurveyResponseView['surveyAnswerList'],
    type: 'create' | 'update' = 'create',
    draft: boolean,
    title: StringOrNull = null,
    dontSendNotification: boolean = false,
    activeQuestions?: number[]
  ) => {
    const {
      addResponse,
      updateResponse,
      surveyItem: { data },
      extraTagIds,
      survey,
      thisUserId,
    } = this.props;

    const scoreRange = this.props.survey.data.fields.find((el) =>
      [
        'conf_responseMessageBasedOnScore',
        'conf_showFollowUpQuestionBasedOnScore',
      ].includes(el.name)
    );

    const response = this.createFinalResponse(type, answerList, title, draft);
    response.tags = [...(response.tags || []), ...(extraTagIds || [])];
    if (activeQuestions) response.activeQuestions = activeQuestions;
    let ret: Promise<any>;
    if (type === 'update') {
      ret = updateResponse(response, data, dontSendNotification).then((e) => {
        this.setState({ selectedResponseId: response.id! });
        if (scoreRange) {
          this.showInformationBasedOnResponseScore(scoreRange.value, response);
        }
        return Promise.resolve(e);
      });
      return ret;
    } else {
      ret = addResponse(
        response,
        data,
        dontSendNotification,
        survey.data.periodType
      ).then(({ response }) => {
        this.setState({
          selectedResponseId: response?.data?.id as number,
          responseId: survey.data.versions[survey.data.currentVersion]
            .fillDurationInMinutes
            ? response?.data?.id
            : undefined,
        });
        const mx = UserMixpanel.getInstance(thisUserId);
        const isIdentification = data.tags.find(
          (item) => item.type === 'Identification'
        );
        mx.sendChecklistOrIndicatorSavedTrack(
          isIdentification ? 'Identification' : 'General Checklist'
        );
        if (this.props.pdpInfo?.phase)
          mx.handleAddNumberOfFilledSurveysPDP(
            this.props.pdpInfo.phase,
            thisUserId
          );

        if (scoreRange) {
          this.showInformationBasedOnResponseScore(
            scoreRange.value,
            response.data
          );
        }

        return Promise.resolve(response);
      });
    }
    ret.then(() => {
      localStorage.setItem(getUniqueSurveyKey(survey), 'true');
    });

    if (
      this.props.surveyType === 'Exam' &&
      type === 'create' &&
      !draft &&
      answerList?.length
    ) {
      this.setState({ showRatingForm: true });
    }
    return ret;
  };
  private createFinalResponse(
    type: 'create' | 'update',
    answerList: ISurveyResponseView['surveyAnswerList'],
    title: StringOrNull,
    draft: boolean
  ) {
    const {
      survey,
      surveyItem: { data },
    } = this.props;
    const { periodType, distinctiveValues } = this.state;
    const tagIDs =
      data.tags.length > 0
        ? data.tags.reduce((temp: number[], tag) => {
            temp.push(Number(tag.id));
            return temp;
          }, [])
        : [];
    let effectiveDate;
    if (periodType && distinctiveValues) {
      const timestamp = distinctiveValues[periodType];
      if (timestamp) {
        effectiveDate = Number(timestamp);
      }
    }
    let finalResponse;
    if (type === 'update') {
      const responseId = Number(this.state.responseId);
      const response: ISurveyResponseView = cloneDeep(
        survey.data.responseMap![responseId]
      );
      response.surveyAnswerList = answerList;
      response.tags = tagIDs;
      response.title = title;
      response.draft = draft;
      response.effectiveDate = effectiveDate;
      response.extraInfo = {
        itemId: data.id,
        providerId: data.providerId,
      };
      finalResponse = response;
    } else {
      const newResponse: ISurveyResponseView = {
        draft,
        title,
        tags: tagIDs,
        instance:
          (distinctiveValues && Number(distinctiveValues.instance)) || data.id,
        surveyId: data.surveyId,
        surveyAnswerList: answerList,
        effectiveDate,
        surveyVersion: survey.data.currentVersion,
        extraInfo: {
          itemId: data.id,
          providerId: data.providerId,
        },
        extraOwnerTokens: this.props.surveyItem.data.extraOwnerTokens,
      };
      finalResponse = newResponse;
    }
    const effectiveDateQuestion = survey.data.versions?.[
      finalResponse.surveyVersion
    ]?.questionList?.find((it) => {
      return it.fields?.some((f) => f.name === 'conf_useAsEffectiveDate');
    });
    if (effectiveDateQuestion) {
      effectiveDate = Number(
        finalResponse.surveyAnswerList.find(
          (a) => a.questionId === effectiveDateQuestion.id
        )?.value
      );
      if (effectiveDate) finalResponse.effectiveDate = effectiveDate;
    }
    return finalResponse;
  }

  handleGetNotifications = (
    answerList: ISurveyResponseView['surveyAnswerList'],
    type: 'create' | 'update' = 'create',
    draft: boolean,
    title: StringOrNull = null
  ) => {
    const {
      getNotifications,
      surveyItem: { data },
    } = this.props;
    const response = this.createFinalResponse(type, answerList, title, draft);
    return getNotifications(response, data);
  };

  // getAnalyse on creating/updating/deleting response
  handleAnalyse = (state: boolean) => () => {
    this.setState({ forceAnalyse: state });
  };

  handleResponseForm = (
    showResponseForm: boolean,
    showDoneSubmit: boolean,
    sentResponseId?: number
  ) => {
    // onCancel prop of ResponseForm
    const {
      showResponseForm: stateShowResponseForm,
      distinctiveValuesForFilter,
      distinctiveValues,
    } = this.state;
    const signOutOnFill =
      (
        this.props.survey.data.fields.find(
          (x: any) => x.name === 'conf_signOutOnFill'
        ) || {
          value: 'false ',
        }
      ).value === 'true';
    const canReport = this.props.surveyItem.data.reportToken;
    if (showDoneSubmit && signOutOnFill && !canReport) {
      setTimeout(() => {
        this.props.logOutUser();
      }, 10000);
    }
    if (this.state.isUnique) {
      this.setState({
        responseId: undefined,
        forceAnalyse: !showResponseForm,
        showResponseForm: showResponseForm,
        showDistinctiveForm: showResponseForm,
        showDoneSubmit,
        sentResponseId,
      });
    }
    this.setState({
      responseId: undefined,
      forceAnalyse: !showResponseForm,
      showResponseForm: showResponseForm,
      showDoneSubmit,
      sentResponseId,
    });

    if (showResponseForm && !stateShowResponseForm) {
      this.setState({
        distinctiveValuesForFilter: distinctiveValues,
      });
    } else if (!showResponseForm && stateShowResponseForm) {
      this.setState({
        distinctiveValues: distinctiveValuesForFilter,
      });
    }
  };

  handleExport = () => {
    this.setState({ loadingExport: true });

    const exportOptions: IExportResponsesQuery = {
      filters: this.state.currentFilter || ([] as IQueryFilter[]),
      includeScore: this.includeScore!.current!.checked,
      includeEmptyResponse: false,
      instanceType: this.props.surveyItem.data.instanceType,
    };
    this.props
      .exportResponses(
        exportOptions,
        this.props.surveyItem.data.reportToken ||
          this.props.surveyItem.data.fillToken,
        undefined,
        this.props.surveyItem.data.extraOwnerTokens?.[0]
      )
      .then(
        () => {
          this.setState({ loadingExport: false });
        },
        () => {
          this.setState({ loadingExport: false });
        }
      );
  };

  handleBackDistinctive = () => {
    let questionAnswered;
    const { distinctiveValues } = this.state;
    if (distinctiveValues) {
      const { currentDate, ...rest } = distinctiveValues;
      questionAnswered = Boolean(
        Object.values(rest).find((item) => item !== null)
      );
    }
    this.setState({
      responseId: undefined,
      showResponseForm: false,
      showDistinctiveForm: false,
      forceAnalyse: questionAnswered,
      distinctiveValues: this.state.distinctiveValuesForFilter,
    });
  };

  handleSetDistinctiveLabels = (
    labelChanges?: {
      distinctiveLabelItem: IDistinctiveLabel;
      show: boolean;
    }[]
  ) => {
    if (labelChanges) {
      // label & order comes from input's data attributes
      const distinctiveLabels: {
        [field: string]: IDistinctiveLabel;
      } = this.state.distinctiveLabels
        ? cloneDeep(this.state.distinctiveLabels)
        : {};
      labelChanges.forEach((labelChange) => {
        const { distinctiveLabelItem, show } = labelChange;
        const { value } = distinctiveLabelItem;
        if (!show) {
          delete distinctiveLabels[value];
        } else {
          distinctiveLabels[value] = distinctiveLabelItem;
        }
      });
      this.setState({ distinctiveLabels });
    } else {
      // to reset distinctiveLabels
      this.setState({ distinctiveLabels: undefined });
    }
  };

  handleSetResponseId = (responseId: number) => (e?: React.MouseEvent) => {
    if (e) {
      e.stopPropagation();
    }
    this.setState({
      responseId,
      showResponseForm: true,
      showDistinctiveForm: Boolean(this.state.isUnique),
      distinctiveValuesForFilter: this.state.distinctiveValues,
    });
  };

  handleValues = (distinctiveValues: IComponentState['distinctiveValues']) => {
    this.setState({ distinctiveValues });
  };

  handleSubmitButton = (disableForm: boolean, loadingSubmit: boolean) => {
    this.setState({ disableForm, loadingSubmit });
  };

  openNextItem = () => {
    savedDistinctiveValues = this.state.distinctiveValues;
    const message =
      (
        this.props.survey.data.fields.find(
          (x: any) => x.name === 'conf_shouldOpenNextMessage'
        ) || {
          value: null,
        }
      ).value || this.props.t('shouldOpenNextMessage');
    if (confirm(message as string)) this.props.openNextItem?.();
  };
  handleSearchByResponseId = () => {
    let responseIdToSearch: number | undefined =
      this.searchValue.current.value &&
      Number(englishNumber(this.searchValue.current.value).replace(/\D/g, ''));
    if (!isANumber(responseIdToSearch)) {
      responseIdToSearch = undefined;
    }
    this.setState({ filteredResponseId: responseIdToSearch });
    if (responseIdToSearch) {
      if (!this.props.survey.data.responseMap![responseIdToSearch])
        this.props.requireResponseWithId(
          this.props.surveyItem.data,
          responseIdToSearch
        );
    }
  };

  handleSearchProvider = (queryString: string) => {
    const promise = new Promise((resolve, reject) => {
      this.props
        .searchProvider(queryString)
        .then(({ providers }) => {
          const searchResult = providers.reduce(
            (
              list: Array<{ id: number; title: string }>,
              provider: IProvider
            ) => {
              const item = {
                id: provider.id,
                title: provider.name || this.props.t('withoutName'),
              };
              list.push(item);
              return list;
            },
            []
          );
          return resolve(searchResult);
        })
        .catch((err: any) => {
          display(err);
          return reject();
        });
    });
    return promise;
  };

  handleSelectProvider = (providerId: string | number) => {
    this.setState({ selectedProviderId: providerId as number, from: 0 }, () =>
      this.handleRequireResponses(0)
    );
  };

  handleRemoveSelectedProvider = () => {
    this.setState({ selectedProviderId: undefined, from: 0 }, () =>
      this.handleRequireResponses(0)
    );
  };

  getPermissionSchemeFilters = () => {
    const ret: IQueryFilter[] = [];
    const surveyItem = this.props.surveyItem.data;
    const { company, thisUserId, currentUserCompanyRoles } = this.props;
    if (!company) return ret;
    const companyMemberRoles = Object.keys(
      company?.members?.[thisUserId || 0]?.roles || {}
    );
    const relatedPermissions = [
      `U${thisUserId}`,
      ...(companyMemberRoles?.map((r) => `R${r}`) || []),
    ];
    Object.values(
      this.props.survey.data.versions[
        this.props.survey.viewingVersion ||
          this.props.survey.data.currentVersion
      ].questionMap || {}
    ).forEach((question: IQuestionsView) => {
      if (
        question.type === 'multipleChoice' &&
        (question.reportPermissionSchemeList?.length ?? 0) > 0
      ) {
        if (question.viewCondition?.refQuestionId) {
          if (
            !question.viewCondition?.questionValues.includes(
              this.state?.distinctiveValues?.[
                question.viewCondition?.refQuestionId
              ]?.toString() || ''
            )
          )
            return;
        }
        const permissionScheme = surveyItem.changeDataToken
          ? []
          : question.reportPermissionSchemeList || [];
        let activeRelatedPermissions = surveyItem?.changeDataToken
          ? []
          : surveyItem?.activePermissions?.effectiveReportPermission?.filter(
              (it) => relatedPermissions.includes(it)
            ) || [];
        if (!thisUserId) activeRelatedPermissions = ['direct']; // direct access (non-logged in)  users bypass permission scheme anyway

        const validChoices = getValidChoices(
          company,
          permissionScheme,
          currentUserCompanyRoles,
          activeRelatedPermissions,
          question.readFromItemTag && this.props.surveyItem.data.upstreamItemId
            ? surveyItem?.tags.map((it) => +it.id)
            : undefined
        );
        if (validChoices)
          ret.push({
            type: 'termFilter',
            field: 'allAnswers',
            values: validChoices.map((v) => `${question.id}$$${v}`),
          });
      }
    });
    return ret;
  };

  requestCounter = 0;
  handleFilterResponses =
    (hasSelectedDistinctive?: boolean) => async (filter: IQueryFilter[]) => {
      this.setState({ currentFilter: filter });
      // avoid analyseList on first render
      if (
        this.state.distinctiveValues ||
        this.state.textFilterValues ||
        this.props.extraTagIds
      ) {
        // avoid analyseList on deselect last distinctive item
        if (hasSelectedDistinctive || this.props.extraTagIds) {
          this.requestCounter++;
          const myCount = this.requestCounter;
          return await this.props
            .filterResponses(filter)
            .then(({ filteredResponsesIds }) => {
              if (myCount === this.requestCounter)
                this.setState({
                  filteredResponsesIds,
                  from: 100, // default server size
                  isAllResponsesLoaded: filteredResponsesIds.length < pageSize,
                });
            });
        }
      }
    };

  handleCloseTaskModal = () => {
    this.setState({ showTaskModal: undefined });
  };
  handleShowTaskModal = (
    responseId?: number,
    templateId?: number,
    templateTitle?: string,
    taskId?: number,
    taskSurveyResponse?: ITaskSurveyResponse
  ) => {
    this.setState({
      showTaskModal: {
        templateId,
        responseId,
        templateTitle,
        taskId,
        taskSurveyResponse,
      },
    });
  };

  handleAcceptedFiles = (files: DropzoneRenderArgs['acceptedFiles']) => {
    const acceptedFile = files[0];
    this.setState({ toImportFile: acceptedFile });
  };

  handleRejectedFiles = () => {
    const warningMessage = this.props.t('invalidFile');
    Toast(warningMessage, 'warning');
  };

  handleSetUrl = (newUrl: string) => {
    this.setState({ htmlUrl: newUrl });
  };

  render() {
    const {
      tags,
      extraTagIds,
      users,
      showCorrectAnswers,
      tasks,
      survey,
      surveyItem,
      thisUserId,
      providers,
      provider,
      canCreateTemplates,
      allTemplatesWithRelatedItem,
      markTaskAssignment,
      thisUser,
      searchTasks,
      company,
      userRoles,
      currentUserCompanyRoles,
      lastPossibleSubmitTime,
      visible,
      filteredQuestionTagId,
    } = this.props;
    const {
      from,
      loading,
      isUnique,
      periodType,
      viewingPeriodType,
      responseId,
      requestSent,
      forceAnalyse,
      showResponseForm,
      selectedResponseId,
      showDistinctiveForm,
      filteredResponsesIds,
      textFilterValues,
      filteredResponseId,
      order,
      loadingExport,
      loadingCompany,
      importWarningMessage,
      showDoneSubmit,
      sentResponseId,
      showTaskModal,
      distinctiveValues,
      isAllResponsesLoaded,
      showRatingForm,
      htmlUrl,
    } = this.state;

    const { domainFeatures } = getDomainAndPort();
    if (
      loading ||
      loadingCompany ||
      !survey.data.versions[
        (showResponseForm ? survey.data.currentVersion : survey.viewingVersion)!
      ]
    ) {
      return (
        <div
          className="progress"
          style={{ display: visible ? undefined : 'none' }}
        >
          <div className="indeterminate" />
        </div>
      );
    }

    let surveyResponseMap = survey.data.responseMap;
    const viewVersion = responseId
      ? surveyResponseMap![responseId].surveyVersion
      : showResponseForm
        ? survey.data.currentVersion
        : survey.viewingVersion;

    const surveyQuestionMap = survey.data.versions[viewVersion!].questionMap;
    if (
      surveyItem.data.instanceType === 'Provider' &&
      this.state.selectedProviderId
    ) {
      // @ts-expect-error it's ok
      surveyResponseMap = Object.values(surveyResponseMap || {}).filter(
        (response: ISurveyResponseView) =>
          response.instance === this.state.selectedProviderId
      );
    }

    let answerList;
    let responseEffectiveDate;
    let hasSelectedDistinctive: boolean | undefined = undefined;

    if (surveyResponseMap && responseId) {
      answerList = surveyResponseMap[responseId].surveyAnswerList.reduce(
        (temp: { [questionId: string]: IAnswerView }, answer: IAnswerView) => {
          temp[answer.questionId] = answer;
          return temp;
        },
        {}
      );
      if (periodType) {
        responseEffectiveDate =
          surveyResponseMap![responseId].effectiveDate! * 1;
      }
    }

    const uniqueSurveyKey = getUniqueSurveyKey(survey);
    const preventReFill =
      this.props.isUniquePerDevice &&
      !surveyItem.data.changeDataToken &&
      localStorage.getItem(uniqueSurveyKey) === 'true';
    const isValidForm =
      !preventReFill && surveyItem.data.fillToken && surveyQuestionMap
        ? (Object.values(surveyQuestionMap) as IQuestionsView[]).filter(
            (question: IQuestionsView | undefined) =>
              !question!.deleted && !question!.disabled
          ).length !== 0
        : false;

    const visibilityStrategy = survey.data.visibilityStrategy;
    const showAddButton =
      (isUnique
        ? isValidForm && !(showDistinctiveForm || showResponseForm)
        : !showResponseForm && isValidForm) &&
      (!visibilityStrategy ||
        (visibilityStrategy === 'protected' &&
          surveyItem.data.changeDataToken) ||
        (visibilityStrategy === 'personal' && thisUserId) ||
        visibilityStrategy === 'open') &&
      (surveyItem.data.changeDataToken ||
        !lastPossibleSubmitTime ||
        lastPossibleSubmitTime > new Date().getTime());
    const user =
      surveyResponseMap && surveyResponseMap[selectedResponseId!]?.userId
        ? users[surveyResponseMap[selectedResponseId!].userId!]
        : undefined;
    const showBackButton = isValidForm && !!thisUserId && showResponseForm;
    let foundDistinctiveQuestion = false;
    const distinctiveQuestions = (
      Object.values(surveyQuestionMap || {}) as IQuestionsView[]
    ).reduce(
      (obj: Record<string, any>, question: IQuestionsView | undefined) => {
        if (
          question!.type === 'multipleChoice' &&
          !(question!.deleted || question!.disabled) &&
          (question!.distinctive ||
            (!showResponseForm && question!.showInTitle))
        ) {
          foundDistinctiveQuestion = true;
          obj[question!.id] = question as IMultipleChoiceQuestionView;
        }
        return obj;
      },
      {} as { [questoinId: number]: IMultipleChoiceQuestionView }
    );

    const hasDistinctiveValue = showResponseForm
      ? foundDistinctiveQuestion ||
        periodType ||
        surveyItem.data.instanceType === 'User'
      : true;
    const surveyDescription = survey.data.description;
    const showUniqueQuestion = thisUserId
      ? hasDistinctiveValue
      : hasDistinctiveValue &&
        (showResponseForm || this.canFetchAllResponses(surveyItem));

    if (this.state.distinctiveValues) {
      const { currentDate, ...rest } = this.state.distinctiveValues;
      hasSelectedDistinctive = !Object.values(rest).every((o) => o === null);
    }

    let allResponses: { [key: string]: ISurveyResponseView } | undefined;
    if (surveyResponseMap) {
      if (filteredResponseId) {
        allResponses = Object.entries(surveyResponseMap)
          .filter((r) => filteredResponseId === r[1].id)
          .reduce((box, it) => {
            box[it[0]] = it[1];
            return box;
          }, {});
      } else if (
        (hasSelectedDistinctive ||
          extraTagIds ||
          !Object.values(textFilterValues || {}).every((o) => o === null)) &&
        filteredResponsesIds
      ) {
        allResponses = Object.entries(surveyResponseMap)
          .filter(
            (r) => filteredResponsesIds.includes(r[1].id!) && !r[1].deleted
          )
          .slice(0, from + pageSize)
          .reduce((box, it) => {
            box[it[0]] = it[1];
            return box;
          }, {});
      } else {
        allResponses = Object.entries(surveyResponseMap)
          .filter((it) => !it[1].deleted)
          .slice(0, from + pageSize)
          .reduce((box, it) => {
            box[it[0]] = it[1];
            return box;
          }, {});
      }
    }

    const getDoneSubmitView = () => {
      let message =
        (
          survey.data.fields.find(
            (x: any) => x.name === 'conf_submitSuccessMessage'
          ) || {
            value: null,
          }
        ).value || this.props.t('doneSubmitResponseMessage');
      message = message?.replace(
        '%id%',
        sentResponseId?.toString() || ''
      ) as string;
      const actionTitle = (
        survey.data.fields.find(
          (x: any) => x.name === 'conf_submitSuccessActionTitle'
        ) || {
          value: null,
        }
      ).value;

      const actionUrl = (
        survey.data.fields.find(
          (x: any) => x.name === 'conf_submitSuccessActionUrl'
        ) || {
          value: null,
        }
      ).value;

      return (
        <div>
          <DoneSubmit>
            <Icon type="check" style={{ fontSize: '3rem' }} />
            <h4>{message}</h4>
          </DoneSubmit>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              padding: '1rem',
            }}
          >
            {actionTitle && actionUrl ? (
              <Button
                style={{ marginInlineEnd: '1rem' }}
                onClick={() => {
                  window.location.href = actionUrl;
                }}
                color="red-outline"
              >
                {actionTitle}
              </Button>
            ) : (
              ''
            )}
            {thisUserId ? (
              <Button
                style={{ float: 'left' }}
                onClick={() => this.handleResponseForm(false, false)}
              >
                {this.props.t('showPrevResponses')}
              </Button>
            ) : (
              <div />
            )}
          </div>
        </div>
      );
    };

    const textFilterQuestions = getTextFilterdQuestions(surveyQuestionMap!);
    const useRandomValues = this.state.randomInput;
    const side = languageDirection() === 'rtl' ? 'left' : 'right';

    const showSingleHtmlPage = !!this.props.survey.data.fields.find(
      (x: any) => x.name === 'conf_htmlResponseDocumentUrl'
    );
    const isSingleResponseSurvey =
      Object.keys(this.props.survey.data.responseMap || {})?.length === 1;

    return (
      <div
        className="modal-content flex-box"
        style={{
          padding: '1.3rem',
          display: visible ? undefined : 'none',
        }}
      >
        {
          <div style={{ zIndex: 10000 }}>
            <RatingForm
              isOpen={showRatingForm || false}
              onClose={() => this.setState({ showRatingForm: false })}
              onSubmit={() => {
                this.setState({ showRatingForm: false });
              }}
              phase={this.props.pdpInfo?.phase}
            />
            <FollowupQuestionsModal
              isOpen={this.state.showFollowupModal}
              onClose={() => this.setState({ showFollowupModal: false })}
              onUpdateResponse={this.handleUpdateSurvey}
              survey={this.props.survey}
              response={allResponses?.[Number(this.state.selectedResponseId)]}
              tags={this.props?.tags}
              questionFollowupInfo={this.state.followUpQuestionsInfo}
              company={this.props?.company}
            />
            {showTaskModal && showTaskModal.templateId && (
              <ItemTask
                companyId={provider.data!.managingCompanyId!}
                templateId={showTaskModal!.templateId}
                providerItem={surveyItem.data}
                tab={'info'}
                fields={[
                  {
                    name: surveyItem.data.name + ' مرتبط',
                    title: surveyItem.data.name + ' مرتبط',
                    value: `${showTaskModal!.responseId}`,
                    type: 'responseLink',
                    options: null,
                  },
                ]}
                taskId={'new'}
                onTaskCreate={(taskId: number) =>
                  this.handleShowTaskModal(
                    undefined,
                    undefined,
                    undefined,
                    taskId
                  )
                }
                onClose={this.handleCloseTaskModal}
                taskSurveyResponse={{
                  reponseItem: showTaskModal.responseId
                    ? survey.data.responseMap![showTaskModal.responseId]
                    : undefined,
                  surveyItem: survey.data.versions[viewVersion!],
                }}
                tags={this.props.tags}
              />
            )}
            {showTaskModal && showTaskModal.taskId && (
              <ItemTask
                companyId={provider.data!.managingCompanyId!}
                taskId={showTaskModal.taskId}
                tab={'info'}
                onClose={this.handleCloseTaskModal}
              />
            )}
          </div>
        }
        {isSingleResponseSurvey && showSingleHtmlPage ? (
          <>
            <IsolatedPage src={htmlUrl} />
          </>
        ) : showDoneSubmit ? (
          getDoneSubmitView()
        ) : (
          <div className="flex flex-col">
            {showAddButton && (
              <div
                style={{
                  alignSelf: 'flex-end',
                  display: 'inline-flex',
                  gap: '10px',
                  float: side,
                  marginBottom: '0.5rem',
                }}
              >
                {this.props.isAdminOrSupport && !!surveyItem.data.editToken && (
                  <Button
                    color="red-outline"
                    style={surveyActionButtonStyle}
                    onClick={() => {
                      this.setState({ randomInput: true });
                      setTimeout(() => {
                        this.setState({ randomInput: false });
                      }, 2000);
                      this.handleResponseForm(true, false);
                    }}
                  >
                    <Icon className="right" type="zap" />
                    {(
                      survey.data.fields.find(
                        (x: any) => x.name === 'conf_newResponse'
                      ) || {
                        value: null,
                      }
                    ).value || this.props.t('randomResponse')}
                  </Button>
                )}
                <Button
                  color="green"
                  style={surveyActionButtonStyle}
                  onClick={() => this.handleResponseForm(true, false)}
                >
                  <Icon className="right" type="plus-circle" />
                  {(
                    survey.data.fields.find(
                      (x: any) => x.name === 'conf_newResponse'
                    ) || {
                      value: null,
                    }
                  ).value || this.props.t('addNewResponse')}
                </Button>
              </div>
            )}
            {showBackButton && (
              <div
                style={{
                  alignSelf: 'flex-end',
                  display: 'inline-flex',
                  gap: '10px',
                  float: side,
                  marginBottom: '0.5rem',
                }}
              >
                <Button
                  color="black-outline"
                  onClick={() =>
                    isUnique
                      ? this.handleBackDistinctive()
                      : this.handleResponseForm(false, false)
                  }
                  style={surveyActionButtonStyle}
                >
                  {this.props.t('showPrevResponses')}
                  <Icon
                    className="left"
                    type={
                      languageDirection() === 'rtl'
                        ? 'arrow-left'
                        : 'arrow-right'
                    }
                  />
                </Button>
              </div>
            )}
            {surveyItem.data.instanceType === 'Provider' && (
              <div className="row">
                <TaskSearch
                  onSearch={this.handleSearchProvider}
                  onSelect={this.handleSelectProvider}
                  placeholder={this.props.t('searchProvider')}
                />
                {this.state.selectedProviderId && (
                  <React.Fragment>
                    <span>
                      {this.props.t('filteredResponsesBasedOn')}:
                      {providers.map![this.state.selectedProviderId].data!.name}
                    </span>
                    <ActionLink
                      color="red"
                      onClick={this.handleRemoveSelectedProvider}
                    >
                      {this.props.t('clear')}
                    </ActionLink>
                  </React.Fragment>
                )}
              </div>
            )}
            {surveyDescription && (
              <Description>
                <div style={{ flexGrow: 1 }}>
                  <CKEditorField
                    // editor={ClassicEditor}
                    data={surveyDescription.replace(/\n/g, '<br>')}
                    disabled={true}
                    dir="rtl"
                    config={CKEditorReadOnlyConfig}
                  />
                </div>
                {/*{surveyDescription}*/}
              </Description>
            )}
            {showUniqueQuestion && (
              <UniqueQuestion
                randomInput={useRandomValues}
                tags={tags}
                extraTagIds={extraTagIds}
                questions={distinctiveQuestions}
                periodType={periodType!}
                viewingPeriodType={viewingPeriodType}
                setViewingPeriodType={(e: TimeScale) => {
                  this.setState({ viewingPeriodType: e });
                }}
                limitRelatedUsers={this.props.limitRelatedUsers}
                responseId={responseId}
                version={survey.data.currentVersion}
                surveyItem={surveyItem.data}
                isAnonymous={
                  !thisUserId && !this.canFetchAllResponses(surveyItem)
                }
                forceAnalyse={forceAnalyse}
                analyseComplete={this.handleAnalyse(false)}
                setChoicesValue={this.handleValues}
                showResponseForm={showResponseForm}
                surveyAnswerList={answerList}
                selectedInstance={
                  surveyResponseMap && surveyResponseMap[responseId!]?.instance
                }
                handleSubmitButton={this.handleSubmitButton}
                showDistinctiveForm={showDistinctiveForm}
                responseEffectiveDate={responseEffectiveDate}
                onSetDistinctiveLabels={this.handleSetDistinctiveLabels}
                onFilterResponses={this.handleFilterResponses(
                  hasSelectedDistinctive
                )}
                visibilityStrategy={visibilityStrategy}
                currentUserCompanyRoles={currentUserCompanyRoles}
                distinctiveValues={showResponseForm ? {} : distinctiveValues}
                response={surveyResponseMap && surveyResponseMap[responseId!]}
                userRoles={userRoles}
                survey={survey.data}
                extraFilters={this.state.permissionSchemeFilters}
                providers={this.props.providers}
                dataSourceValues={this.state.externalDataSourceValues}
                onSelectResponse={(rid: number) => {
                  this.setState(
                    { responseId: undefined, showResponseForm: false },
                    () => {
                      this.handleSetResponseId(rid)();
                    }
                  );
                }}
              />
            )}
            {preventReFill && (
              <QuestionHintBox color={red}>
                <HintIcon type="alert-triangle" color={red} />
                <HintText style={{ color: red }}>
                  <span>{messages.preventRefill}</span>
                </HintText>
              </QuestionHintBox>
            )}
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                }}
              >
                {this.state.distinctiveLabels && !showResponseForm && (
                  <DistinctiveBadges
                    distinctiveLabels={
                      Object.values(this.state.distinctiveLabels) as IOption[]
                    }
                  />
                )}

                {!showResponseForm && textFilterQuestions.length ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      minWidth: '310px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        columnGap: '10px',
                        overflow: 'auto',
                        padding: '0 5px',
                        margin: ' 0 0 0 10px',
                      }}
                    >
                      {textFilterQuestions.map((q) => {
                        return (
                          <Input
                            wrapperStyle={{ flexShrink: 0 }}
                            key={q.id}
                            id={'filter' + q.id}
                            type="text"
                            style={{ height: '30px' }}
                            value={this.state.textFilterValues?.[q.id] || ''}
                            onChange={(e) => {
                              this.setState({
                                textFilterValues: {
                                  ...this.state.textFilterValues,
                                  [q.id]: e.target.value,
                                },
                              });
                            }}
                            placeholder={q.title}
                            // label={q.title}
                            onKeyDown={(e: React.KeyboardEvent) => {
                              if (e.keyCode === 13) {
                                this.handleSearchWithText();
                              }
                            }}
                          />
                        );
                      })}
                    </div>
                    <Button
                      onClick={this.handleSearchWithText}
                      color="blue-outline"
                      style={{ height: '30px' }}
                    >
                      <Icon type="search" />
                      {this.props.t('search')}
                    </Button>
                  </div>
                ) : (
                  <div />
                )}
              </div>
            </div>
            {showResponseForm ? (
              <ResponseForm
                randomInput={useRandomValues}
                isEditor={!!surveyItem.data.editToken}
                askTitle={survey.data.askTitle}
                recommendRefill={survey.data.recommendRefill}
                submitMessage={
                  (
                    survey.data.fields.find(
                      (x: any) => x.name === 'conf_submitSuccessMessage'
                    ) || {
                      value: '',
                    }
                  ).value
                }
                thisUserId={thisUserId}
                userRoles={userRoles}
                preventDraft={
                  (
                    survey.data.fields.find(
                      (x: any) => x.name?.toLowerCase() === 'conf_allowdraft'
                    ) || {
                      value: 'true',
                    }
                  ).value?.toLowerCase() === 'false'
                }
                tags={tags!}
                setViewState={this.handleResponseForm}
                singleResponseOnly={
                  !thisUserId || survey.data.keepResponsesAnonymous
                }
                isUnique={foundDistinctiveQuestion}
                response={surveyResponseMap && surveyResponseMap[responseId!]}
                questions={surveyQuestionMap as any}
                anonymous={survey.data.keepResponsesAnonymous}
                periodType={periodType || 'none'}
                selectedPeriod={
                  this.state.distinctiveValues &&
                  Number(this.state.distinctiveValues[periodType || 'none'])
                }
                disableForm={this.state.disableForm || preventReFill}
                loadingSubmit={this.state.loadingSubmit}
                survey={survey.data}
                updateAnalyse={this.handleAnalyse(true)}
                lastPossibleSubmitTime={
                  surveyItem.data.changeDataToken
                    ? undefined
                    : lastPossibleSubmitTime
                }
                onSaveResponse={this.handleSaveResponse}
                onGetNotifications={this.handleGetNotifications}
                loadUsers={this.props.requireSeveralUser}
                users={users}
                distinctiveValues={this.state.distinctiveValues}
                item={surveyItem}
                company={company}
                currentUserCompanyRoles={currentUserCompanyRoles}
                openNextItem={this.openNextItem}
                dataSourceValues={this.state.externalDataSourceValues}
                surveyResponseUploadedProgress={
                  this.props.surveyResponseProgress
                }
              />
            ) : (
              <React.Fragment>
                <Wrapper>
                  {surveyResponseMap ? (
                    !showResponseForm && (
                      <ResponseListWrapper halve={!!selectedResponseId}>
                        <ResponseListHeader>
                          <SearchWrapper>
                            <SearchInput
                              SearchWrapper
                              ref={this.searchValue}
                              type="text"
                              placeholder={this.props.t('searchById')}
                              defaultValue={filteredResponseId}
                              onKeyDown={(event: KeyboardEvent) => {
                                if (event.keyCode === 13) {
                                  this.handleSearchByResponseId();
                                }
                              }}
                            />
                            {filteredResponseId && (
                              <ClearSearchIcon
                                type="x"
                                onClick={() => {
                                  this.searchValue.current.value = '';
                                  this.handleSearchByResponseId();
                                }}
                              />
                            )}
                            <SearchIcon
                              iconName="search-normal.svg"
                              color={black}
                              type="sm"
                              style={{
                                position: 'absolute',
                                top: '0.3rem',
                                [side]: '0.2rem',
                              }}
                              onClick={this.handleSearchByResponseId}
                            />
                          </SearchWrapper>
                          {/* <HeaderInfo>
                            {messages.loadedResponses(
                              convertNumbersToProperFormat(allResponses.size)
                            )}
                          </HeaderInfo>*/}
                          <Select
                            round={true}
                            onChangeValues={(e) => {
                              this.setOrder(e[0].value as any);
                            }}
                            allowRemove={false}
                            values={[
                              this.responseListOrder.find(
                                (it) => it.value === order
                              )!,
                            ]}
                            options={this.responseListOrder}
                          />
                        </ResponseListHeader>
                        <ResponseList
                          tags={tags!}
                          item={surveyItem}
                          users={users}
                          canEdit={
                            !!surveyItem.data.editToken ||
                            !!surveyItem.data.changeDataToken
                          }
                          canEditSensitive={
                            !!surveyItem.data.editToken ||
                            (!survey.data.sensitiveChangeRequiresEditor &&
                              !!surveyItem.data.changeDataToken)
                          }
                          onRemove={this.handleRemove}
                          onUpdate={this.handleUpdateSurvey}
                          // periodType={this.state.periodType}
                          thisUserId={thisUserId}
                          updateAnalyse={this.handleAnalyse(true)}
                          onEditResponse={this.handleSetResponseId}
                          onClickOnResponse={this.handleChangeResponseViewer}
                          createTask={this.handleShowTaskModal}
                          selectedResponseId={selectedResponseId}
                          order={order}
                          survey={survey.data as ISurveyView}
                          // distinctiveQuestions={distinctiveQuestions}
                          responses={allResponses}
                          templates={canCreateTemplates}
                          searchTasks={searchTasks}
                          company={company}
                          htmlUrl={this.state.htmlUrl}
                          onSetHtmlUrl={this.handleSetUrl}
                        />
                        <LoadMoreResponsesContainer>
                          <LoadMoreText>
                            {() => {
                              const allResponseCounter: number = Object.keys(
                                allResponses || {}
                              ).length;
                              return this.props.t('loadedResponses', {
                                count:
                                  this.activeLanguage === 'fa'
                                    ? convertNumbersToProperFormat(
                                        allResponseCounter
                                      )
                                    : allResponseCounter,
                              });
                            }}
                          </LoadMoreText>
                          {Object.keys(surveyResponseMap).length >=
                            pageSize && (
                            <Button
                              color="green"
                              loading={requestSent}
                              onClick={this.handleRequireResponses()}
                              disabled={isAllResponsesLoaded}
                            >
                              {this.props.t('previousResponses')}
                            </Button>
                          )}
                        </LoadMoreResponsesContainer>
                      </ResponseListWrapper>
                    )
                  ) : (
                    <ViewList hiddenIfSmall={false}>
                      <QuestionHintBox
                        style={{
                          width: 'fit-content',
                          margin: 'auto',
                          marginTop: '20%',
                        }}
                      >
                        <HintIcon type="info" />
                        <HintText>
                          <span>
                            {(
                              survey.data.fields.find(
                                (x: any) => x.name === 'conf_emptyMessage'
                              ) || {
                                value: null,
                              }
                            ).value || this.props.t('thereIsNoAnswerYet')}
                          </span>
                        </HintText>
                      </QuestionHintBox>
                    </ViewList>
                  )}
                  {(() => {
                    const withInLockEditDuration =
                      selectedResponseId &&
                      surveyResponseMap![selectedResponseId!].submitDate! +
                        (survey.data.fillDurationInMinutes || 0) * 60 * 1000 >
                        new Date().valueOf();

                    return (
                      <ResponseViewer
                        user={user!}
                        surveyItem={surveyItem}
                        users={users}
                        showCorrectAnswers={
                          showCorrectAnswers && !withInLockEditDuration
                        }
                        canEdit={
                          withInLockEditDuration ||
                          (!!selectedResponseId &&
                            surveyResponseMap &&
                            (!!surveyItem.data.editToken ||
                              (!!surveyItem.data.changeDataToken &&
                                (!survey.data.sensitiveChangeRequiresEditor ||
                                  !surveyResponseMap![selectedResponseId]
                                    .lock)) ||
                              (!surveyResponseMap![selectedResponseId].lock &&
                                surveyResponseMap![selectedResponseId]
                                  .userId === thisUserId))) ||
                          false
                        }
                        onEditResponse={this.handleSetResponseId}
                        response={
                          selectedResponseId
                            ? surveyResponseMap![selectedResponseId]
                            : undefined
                        }
                        // searchTasks={searchTasks}
                        tasks={tasks}
                        thisUser={thisUser}
                        companyId={
                          provider.data?.managingCompanyId ?? undefined
                        }
                        hasRelatedTemplate={
                          allTemplatesWithRelatedItem.length > 0
                        }
                        markTaskAssignment={markTaskAssignment}
                        handleShowTask={(taskId: number) =>
                          this.handleShowTaskModal(
                            undefined,
                            undefined,
                            undefined,
                            taskId
                          )
                        }
                        companyOwnerId={provider?.data?.user}
                        survey={survey.data as ISurveyView}
                        onCloseResponse={this.handleChangeResponseViewer}
                        tags={tags!}
                        company={company}
                        domainFeatures={domainFeatures}
                        loadingExport={loadingExport}
                        handleExport={this.handleExport}
                        includeScore={this.includeScore}
                        onReject={this.handleRejectedFiles}
                        onDrop={this.handleAcceptedFiles}
                        importFile={this.state.toImportFile}
                        importExcel={this.importFromExcel}
                        importWarningMessage={importWarningMessage}
                        templates={canCreateTemplates}
                        onCreateTask={this.handleShowTaskModal}
                        filteredQuestionTagId={filteredQuestionTagId}
                        htmlUrl={this.state.htmlUrl}
                        onSetHtmlUrl={this.handleSetUrl}
                      />
                    );
                  })()}
                </Wrapper>
              </React.Fragment>
            )}
          </div>
        )}
      </div>
    );
  }

  handleSearchWithText = () => {
    const entries = Object.entries(this.state.textFilterValues || {}).filter(
      (it) => !!it[1]
    );
    this.setState({ textFilterValues: Object.fromEntries(entries) });
    const textFilters = entries.map((it) => {
      return {
        type: 'generalTermFilter',
        query: `allAnswers:${it[0]}$$*${it[1].replaceAll(' ', '\\ ')}*`,
        field: 'allAnswers',
      } as IQueryFilter;
    });
    const { distinctiveValues } = this.state;
    const hasDistinctiveFilter = !Object.values(distinctiveValues || {}).every(
      (o) => o === null
    );
    this.handleFilterResponses(hasDistinctiveFilter || !!textFilters.length)([
      ...(this.state.currentFilter || []).filter(
        (e) => e.type !== 'generalTermFilter'
      ),
      ...textFilters,
    ]);
  };
}

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  props
) => {
  const survey = state.survey.data[props.surveyItem.data.surveyId];
  const users = state.users.map;
  const providerId = props.surveyItem.data.providerId;
  const thisUser = state.thisUser;
  const thisUserId = Number(thisUser.userId);
  const tags = state.providers.tags?.[providerId]?.data;
  const providers = state.providers;
  const provider = providers.map[providerId];
  const companyId = provider?.data?.managingCompanyId;
  const surveyResponseProgress = state.survey.uploadProgress.byQuestion;

  const company = companyId ? state.companies.data[companyId] : undefined;
  const userRoles = company?.members
    ? company?.members[thisUserId]?.roles
      ? Object.values(company.members[thisUserId]?.roles)?.map(
          (item: ICompanyMemberRole) => item.id
        )
      : []
    : [];
  const projects = company?.projects;
  const tasks = state.tasks;
  const canCreateTemplates: { id: number; title: string }[] = [];
  const allTemplatesWithRelatedItem: { id: number; title: string }[] = [];
  if (company && company.status === 'loaded') {
    const canCreateProjects = Object.values(projects || {}).filter(
      (project) => {
        const member = project.myMembership;
        if (member) {
          return member.canCreate;
        }
        return false;
      }
    );

    Object.values(company?.templates || {}).forEach((template) => {
      if (template.suggestOnDocumentManager) {
        const templateItem = {
          id: template.taskId,
          title: tasks.data[template.taskId].taskName,
        };
        allTemplatesWithRelatedItem.push(templateItem);
        if (
          canCreateProjects.find((project) =>
            project.templates.find((it) => it.taskId === template.taskId)
          )
        ) {
          canCreateTemplates.push(templateItem);
        }
      }
    });
  }

  const currentUserCompanyRoles: number[] = Object.keys(
    state.companies?.data?.[companyId!]?.members?.[thisUserId]?.roles || {}
  )?.map((it) => Number(it));

  const isAdminOrSupport =
    Boolean(thisUserId === state.providers.map[providerId].data?.user) ||
    Boolean(company && isCompanyOwnerOrSupport(thisUser, company));
  const isUniquePerDevice = !!survey?.data.fields.find(
    (it) => it.name === 'conf_uniquePerDevice' && it.value !== 'false'
  );
  return {
    survey,
    userRoles,
    users,
    providerId,
    thisUserId,
    thisUser,
    tags,
    providers,
    provider,
    canCreateTemplates,
    allTemplatesWithRelatedItem,
    currentUserCompanyRoles,
    tasks,
    company: company ?? undefined,
    isAdminOrSupport,
    isUniquePerDevice,
    surveyResponseProgress,
  };
};

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IComponentProps
> = (_, props) => {
  return {
    addResponse: (
      response: ISurveyResponseView,
      surveyItemData: ISurveyItem,
      dontSendNotification: boolean,
      periodType: PeriodType
    ) =>
      appDispatch(
        addResponse({
          response,
          surveyItemData,
          dontSendNotification,
          periodType,
        })
      ),
    getNotifications: (
      response: ISurveyResponseView,
      surveyItemData: ISurveyItem
    ) => appDispatch(getNotifications({ response, surveyItemData })),
    removeResponse: (responseId: number, surveyItemData: ISurveyItem) =>
      appDispatch(removeResponse({ responseId, surveyItemData })),
    updateResponse: (
      response: ISurveyResponseView,
      surveyItemData: ISurveyItem,
      dontSendNotification: boolean
    ) =>
      appDispatch(
        updateResponse({
          response,
          surveyItemData,
          dontSendNotification,
        })
      ),
    requireResponsesWithUsers: (
      surveyItemData: ISurveyItem,
      start: number,
      count: number,
      instance?: number,
      thisUserId?: number,
      order?: string,
      extraFilters?: IQueryFilter[]
    ) => {
      let finalExtraFilters = extraFilters || [];
      if (props.extraTagIds && props.extraTagIds.length) {
        finalExtraFilters = [
          ...finalExtraFilters,
          ...props.extraTagIds!.map(
            (it) =>
              ({
                field: 'tags',
                values: [it],
                type: 'termFilter',
              }) as IQueryFilter
          ),
        ];
      }
      return appDispatch(
        requireResponsesWithUsers({
          surveyItemData,
          start,
          count,
          instance: surveyItemData.ignoreInstance ? undefined : instance,
          thisUserId,
          order,
          extraFilters: finalExtraFilters,
        })
      );
    },
    requireResponseWithId: (surveyItemData: ISurveyItem, responseId: number) =>
      appDispatch(
        requireResponseWithId({
          surveyItemData,
          responseId,
          includeDeletedResponse: true,
        })
      ),
    filterResponses: (filters: IAnalyticsListQuery['filters']) => {
      if ((props.extraTagIds?.length ?? 0) > 0) {
        filters = [
          ...filters,
          ...props.extraTagIds!.map(
            (it) =>
              ({
                field: 'tags',
                values: [it],
                type: 'termFilter',
              }) as IQueryFilter
          ),
        ];
      }
      return appDispatch(
        filterResponsesByDistinctive({
          filters,
          surveyItem: props.surveyItem.data,
        })
      );
    },
    searchProvider: (
      queryString: string,
      variant?: string | null,
      start?: number,
      count?: number
    ) => appDispatch(searchProvider({ queryString, variant, start, count })),
    requireProviderTags: (providerId: number) =>
      appDispatch(requireProviderTags({ providerId })),
    exportResponses: (
      query: IExportResponsesQuery,
      surveyToken?: string,
      ownerToken?: string,
      reportToken?: string
    ) =>
      appDispatch(
        exportResponses({
          dataQuery: query,
          surveyToken,
          reportToken,
          ownerToken,
        })
      ),
    logOutUser: () => appDispatch(logoutUser({ shouldRedirect: true })),
    requireSeveralUser: (userIds: number[]) =>
      appDispatch(requireSeveralUser({ usersList: userIds })),
    searchTasks: (params: ISearchParams) =>
      appDispatch(searchTasks({ params })),
    markTaskAssignment: (assignment: IAssignmentView) =>
      appDispatch(markTaskAssignment({ assignment })),
    importResponses: (
      file: File,
      surveyItemData: ISurveyItem,
      dontSendNotification: boolean,
      companyId: number
    ) =>
      appDispatch(
        importResponse({
          file,
          surveyItemData,
          dontSendNotification,
          companyId,
        })
      ),
    getCompany: (companyId: number) =>
      appDispatch(
        getCompanyHandler({
          companyId,
          templateStub: false,
          companyStub: false,
          projectStub: false,
          taskStub: false,
        })
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation('survey')(SurveyResponseViewer));
